module.exports = __webpack_public_path__ + "img/dracula-10.52b6c62f.jpg";